import { PrimitiveBlueprint } from "../types";
import { AVATAR_SIZE_CLASSES } from "./sizeClasses";
import { PRIMITIVE_COLORS } from "../../constants";

/**
 * Barbarian avatar - fierce warrior with red/orange color scheme
 * Visually distinct from Warrior (blue/silver tones) with warmer, aggressive colors
 */
const BARBARIAN_COLORS = {
  wood: PRIMITIVE_COLORS.stone, // Brown body (same as warrior)
  trim: PRIMITIVE_COLORS.orange, // Orange trim (vs warrior's amber)
  accent: PRIMITIVE_COLORS.red, // Red accent (vs warrior's lightSky)
  core: PRIMITIVE_COLORS.lightRed, // Light red core (vs warrior's cyan)
  mask: PRIMITIVE_COLORS.darkSlate, // Dark mask
  border: PRIMITIVE_COLORS.darkSlate, // Dark border
  shadow: PRIMITIVE_COLORS.black,
  spike: PRIMITIVE_COLORS.lightYellow, // Yellow spikes for distinction
};

export const BARBARIAN_BLUEPRINT: PrimitiveBlueprint = {
  id: "barbarian",
  designSize: AVATAR_SIZE_CLASSES.MEDIUM,
  parts: [
    {
      id: "shadow",
      type: "ellipse",
      bounds: { x: 0.14, y: 0.84, w: 0.72, h: 0.14 },
      style: { fill: BARBARIAN_COLORS.shadow, fillAlpha: 0.28 },
      z: 0,
    },
    {
      id: "pillar",
      type: "roundRect",
      bounds: { x: 0.18, y: 0.08, w: 0.64, h: 0.78 },
      style: {
        fill: BARBARIAN_COLORS.wood,
      },
      z: 1,
    },
    {
      id: "cap",
      type: "roundRect",
      bounds: { x: 0.14, y: 0.06, w: 0.72, h: 0.18 },
      style: {
        fill: BARBARIAN_COLORS.border,
        stroke: BARBARIAN_COLORS.trim,
        strokeWidth: 3,
      },
      z: 2,
    },
    // Horns/spikes on helmet for barbarian distinction
    {
      id: "spike-left",
      type: "triangle",
      bounds: { x: 0.12, y: 0.04, w: 0.1, h: 0.12 },
      style: {
        fill: BARBARIAN_COLORS.spike,
        stroke: BARBARIAN_COLORS.trim,
        strokeWidth: 2,
      },
      z: 3,
    },
    {
      id: "spike-right",
      type: "triangle",
      bounds: { x: 0.78, y: 0.04, w: 0.1, h: 0.12 },
      style: {
        fill: BARBARIAN_COLORS.spike,
        stroke: BARBARIAN_COLORS.trim,
        strokeWidth: 2,
      },
      z: 3,
    },
    {
      id: "visor",
      type: "roundRect",
      bounds: { x: 0.2, y: 0.56, w: 0.6, h: 0.2 },
      style: {
        fill: BARBARIAN_COLORS.mask,
        stroke: BARBARIAN_COLORS.trim,
        strokeWidth: 3,
      },
      z: 4,
    },
    {
      id: "band",
      type: "rect",
      bounds: { x: 0.2, y: 0.32, w: 0.6, h: 0.12 },
      style: {
        fill: BARBARIAN_COLORS.accent,
        stroke: BARBARIAN_COLORS.trim,
        strokeWidth: 2,
      },
      z: 5,
    },
    {
      id: "core",
      type: "rect",
      bounds: { x: 0.36, y: 0.3, w: 0.28, h: 0.2 },
      style: {
        fill: BARBARIAN_COLORS.core,
      },
      z: 6,
    },
    {
      id: "eye-left",
      type: "ellipse",
      bounds: { x: 0.32, y: 0.22, w: 0.12, h: 0.08 },
      style: {
        fill: BARBARIAN_COLORS.trim,
        stroke: BARBARIAN_COLORS.border,
        strokeWidth: 2,
      },
      z: 7,
    },
    {
      id: "eye-right",
      type: "ellipse",
      bounds: { x: 0.56, y: 0.22, w: 0.12, h: 0.08 },
      style: {
        fill: BARBARIAN_COLORS.trim,
        stroke: BARBARIAN_COLORS.border,
        strokeWidth: 2,
      },
      z: 7,
    },
    // Skull emblem instead of triangle for barbarian
    {
      id: "emblem",
      type: "ellipse",
      bounds: { x: 0.42, y: 0.48, w: 0.16, h: 0.14 },
      style: {
        fill: BARBARIAN_COLORS.spike,
        stroke: BARBARIAN_COLORS.border,
        strokeWidth: 2,
      },
      z: 8,
    },
    {
      id: "chevron",
      type: "line",
      bounds: { x: 0.3, y: 0.7, w: 0.4, h: 0.04 },
      style: { stroke: BARBARIAN_COLORS.accent, strokeWidth: 4 },
      z: 9,
    },
  ],
};
